
import { platformSetupTour } from "./tours/platform-setup";
import { dashboardOverviewTour } from "./tours/dashboard-overview";
import { mySurveysTour } from "./tours/my-surveys";
import { usersGuideTour } from "./tours/users-guide";
import { levelConfigTour } from "./tours/level-config";
import { achievementCreateTour } from "./tours/achievement-create";

export const tours = [
  platformSetupTour,
  dashboardOverviewTour,
  mySurveysTour,
  usersGuideTour,
  levelConfigTour,
  achievementCreateTour,
];
